import Icon from '@/common/components/Icon';
import { STATUS_DIAPLAY_MAP } from '@/pages/admin/followUpPayments/constants/statusDisplayMap';
import { buildComment } from '@/pages/admin/followUpShipments/helpers/buildComment';
import moment from 'moment';

export const getTableRows = (data, onActionClick) => {
	return data.map((row, idx) => (
		<tr>
			<td>{idx + 1}.</td>
			<td>{row.customer.names}</td>
			<td>{row.customer.phoneNo}</td>
			<td>{STATUS_DIAPLAY_MAP[row.payment.status]}</td>
			<td>{moment(row.payment.statusDate).format('YYYY-MM-DD HH:mm')}</td>
			<td>{buildComment(row.ccCalls?.[0])}</td>
			<td>
				{row.ccCalls?.[0]?.date &&
					moment(row.ccCalls[0].date).format('YYYY-MM-DD HH:mm')}
			</td>
			<td>{buildComment(row.ccCalls?.[1])}</td>
			<td>
				{row.ccCalls?.[1] &&
					moment(row.ccCalls?.[1]?.date).format('YYYY-MM-DD HH:mm')}
			</td>
			{!row.ccCalls?.[1] ? (
				<td>
					<Icon
						name='plus'
						style={{
							color: 'black',
							cursor: 'pointer',
						}}
						onClick={() => onActionClick(row.orderId)}
					/>
				</td>
			) : (
				<td></td>
			)}
		</tr>
	));
};
